module.exports = __webpack_public_path__ + "img/close-alert.8b64ec09.svg";